import type { OneTimeProduct } from '@weft/services';
import React from 'react';
import { Price } from '../../../../../../../components/design/Price';
import { useChargeContext } from '../../../charge-context';
import { PlanChargesContainer } from '../../../PlanChargesContainer';
import { getFixedChargePrice } from '../../fixed-charges-services/get-fixed-charge-price';

export const FixedOneTimeChargeView: React.FC = () => {
  const { item: product, currency } = useChargeContext<OneTimeProduct>();
  const [firstVariant] = product.variants;
  const { name, description } = firstVariant;

  const [productVariant] = product.variants;

  return (
    <PlanChargesContainer
      key={product.id}
      className="border-none bg-transparent pt-4"
    >
      <div className='divide-line space-y-8 divide-y'>
        <div key={productVariant.id}>
          <div className="flex justify-between pb-4">
            <div className="flex flex-col space-x-0.5">
              <p className="text-lg font-medium">{name}</p>
              {description && (
                <p className="text-label2 text-sm">{description}</p>
              )}
            </div>
            <div className="flex flex-col items-end space-x-0.5 text-right">
              <p className="text-placeholder text-sm">Amount</p>
              <Price
                currency={currency}
                align="right"
                className="text-xl font-medium"
              >
                {getFixedChargePrice(productVariant.pricing)}
              </Price>
            </div>
          </div>
        </div>
      </div>
    </PlanChargesContainer>
  );
};